import * as React from 'react'
import { Box, Typography } from "@mui/material";
import { formatPercentage, formatPriceSymbol } from "@ui-seeker/utils";

import { NotAllowedBlock, RetailerBlock } from "@components";


export default function minPriceColumn() {
    return {
        name: 'minSkuPrice', label: 'Market Min Price',
        options: {
            setCellHeaderProps: () => ({ sx: {
                    whiteSpace: 'pre-wrap',
                }}),
            customBodyRowRenderLite: (value, { currency, minSeller, diffMinPrice, minSiteID, minSite, minSiteURL, minSiteCountry  }) => <Box sx={{ textAlign: 'center' }}>
                {!!value && <MinPriceColumn
                    minPrice={value}
                    currency={currency}
                    minSeller={minSeller}
                    minSiteID={minSiteID}
                    minSite={minSite}
                    minSiteURL={minSiteURL}
                    minSiteCountry={minSiteCountry}
                    diffMinPrice={diffMinPrice}
                />}
                {!value && <NotAllowedBlock />}
            </Box>
        }
    }
}

const MinPriceColumn = ({ minPrice, currency, minSeller, diffMinPrice, minSiteID, minSite, minSiteURL, minSiteCountry }) => {
    return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <Box>
            {formatPriceSymbol(minPrice, currency, { displayZero: true })}
            <Typography variant="caption" sx={{ color: diffMinPrice <= 0 ? 'error.main' : 'success.dark', ml: .5}}>
                {formatPercentage(diffMinPrice)}
            </Typography>
        </Box>
        <Typography variant={'subtitle2'} sx={{ fontStyle: 'italic', color: 'disabled.darker' }}>{minSeller}</Typography>
        <RetailerBlock
            retailer={minSite}
            country={minSiteCountry}
            siteURL={minSiteURL}
        />
    </Box>
}